module.exports = __webpack_public_path__ + "images/VivaEngageLogo-9fd97eabca0359128579d8c663561348.svg";